import React, { useEffect, useState } from "react";
import { useSubheader } from "../../../../_metronic/layout";
import {
  makeStyles,
  Paper,
  Grid,
  List,
  Divider,
  ListItem,
  Button,
} from "@material-ui/core";
// import { Link } from "react-router-dom";
import _ from "lodash";
import { shallowEqual, useSelector } from "react-redux";
// import { useFormik } from "formik";
import httpClientService from "../../../helpers/apiHelper";

import { Spinner } from "react-bootstrap";
// import Alert from "@material-ui/lab/Alert";
// import { useHistory } from "react-router-dom";
import * as Yup from "yup";
import { Formik } from "formik";

// components
import TokenAlert from "../../../components/TokenAlert";
import Breadcrumb from "../../../components/Breadcrumb";
import Config from "../../../helpers/Config";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    backgroundColor: theme.palette.background.paper,
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
  select: {
    minWidth: 200,
  },
  paper: {
    width: "100%",
    minHeight: 700,
    marginBottom: theme.spacing(2),
    padding: theme.spacing(4),
  },
  input: {
    width: "250px",
  },
  alignCenter: {
    display: "flex",
    flexWrap: "no-wrap",
    alignItems: "center",
    padding: "5px 0 !important",
  },
  textField: {
    marginRight: theme.spacing(1),
    width: 200,
  },
  remark: {
    minWidth: "400px",
    minHeight: "150px",
  },
  clickableAlert: {
    marginBottom: theme.spacing(3),
    cursor: "pointer",
  },
}));
// const radioStyles = makeStyles((theme) => ({
//   formControl: {
//     margin: theme.spacing(3),
//   },
//   group: {
//     display: "flex",
//     flexDirection: "row",
//     alignItems: "center",
//   },
// }));

const Registration = (props) => {
  // const history = useHistory();
  const suhbeader = useSubheader();
  const classes = useStyles();
  // const radioClasses = radioStyles();
  // const [startRadio, seteStartRadio] = useState("0");
  const domin = Config.get("API_HOST");

  suhbeader.setTitle("修改密碼");
  // 選擇貨運公司的設定
  // const [selectFreightType, setSelectFreightType] = useState("");
  // const [freightTypeOption, setFreightTypeOption] = useState([]);
  const [err, seterr] = React.useState("");
  const [hasntToken, setHasntToken] = React.useState("");
  // const [success, setSuccess] = React.useState("");
  // const [addSuccess, setAddSuccess] = React.useState(false);
  // const [freightCode, setFreightCode] = React.useState("");
  // const [freightName, setFreightName] = React.useState("");
  const authToken = useSelector(({ auth }) => auth.authToken, shallowEqual);

  const user = useSelector(({ auth }) => auth.user, shallowEqual);
  useEffect(() => {}, [user]);

  // function addSuccessOpen() {
  //   setAddSuccess(true);
  // }
  // function addSuccessClose() {
  //   setAddSuccess(false);
  // }
  useEffect(() => {
    setFreightTypeOptionValue();
  }, [authToken]);

  // 讀取使用者資料
  function setFreightTypeOptionValue() {
    // const url = `${domin}/system/options`;
  }

  //是否在讀取
  const [loading, setLoading] = useState(false);

  const enableLoading = () => {
    setLoading(true);
  };

  const disableLoading = () => {
    setLoading(false);
  };

  const userSchema = Yup.object().shape({
    // id: Yup.string().required("此為必填欄位"),
    // logisticsType: Yup.string().required("此為必填欄位"),
    // name: Yup.string().required("此為必填欄位"),
    // address: Yup.string().required("此為必填欄位"),
    // contact: Yup.string().required("此為必填欄位"),
    // phone: Yup.string().required("此為必填欄位"),
    // status: Yup.string().required("此為必填欄位"),
    // comment: Yup.string().required("此為必填欄位"),
  });

  let initialData = {
    currentPassword: "",
    newPassword: "",
    repeatNewPassword: "",
  };

  return (
    <>
      <Breadcrumb path={props.location.pathname}></Breadcrumb>
      <TokenAlert showMsg={hasntToken}></TokenAlert>
      {hasntToken ? (
        <></>
      ) : loading ? (
        <Spinner animation="border" variant="primary" className="m-7" />
      ) : err ? (
        <></>
      ) : (
        <>
          <Formik
            initialValues={initialData}
            enableReinitialize
            validationSchema={userSchema}
            // 送出並修改資料
            onSubmit={(values) => {
              // setComment(values.comment);
              // console.log('responseLogisticType = ', responseLogisticType)
              const submitdata = {
                password: values.currentPassword,
                new_password: values.repeatNewPassword,
              };

              console.log("submitdata = ", submitdata);
              // setSuccess("");
              enableLoading();
              const url = `${domin}/vendor/password`;
              httpClientService("post", url, authToken, submitdata)
                .then((res) => {
                  console.log("res:", res.msg);

                  if (!_.get(res, "result")) {
                    console.log(_.get(res, "msg"));
                    if (
                      _.get(res, "msg") ===
                      ("查無此Token，請重新登入" || "此Token失效，請重新登入" || "登入失敗查無此Token，請重新登入")
                    ) {
                      setHasntToken(res.msg);
                      disableLoading();
                      return;
                    }
                    seterr(res.msg);
                    // editSuccessOpen()
                    disableLoading();
                    return;
                  }

                  if (!_.get(res, "result")) {
                    seterr(res.msg);
                    disableLoading();
                  } else {
                    // editSuccessOpen();
                    disableLoading();
                  }
                  disableLoading();
                })
                .catch((err) => {
                  console.log(err);
                  seterr(err.toString());
                  // editSuccessOpen()
                  disableLoading();
                });
            }}
          >
            {(formik) => {
              return (
                <>
                  <Paper className={classes.paper + " p-5 "}>
                    <form>
                      <Grid container spacing={3}>
                        <Grid
                          item
                          xs={12}
                          sm={3}
                          lg={3}
                          className="d-flex align-items-center pb-0"
                        >
                          <h2>修改密碼</h2>
                        </Grid>
                        <Grid
                          item
                          xs={12}
                          sm={9}
                          lg={9}
                          className="d-flex align-items-center pb-0"
                        >
                          <span className="ml-5">
                            (建議您定期更改密碼，以確保帳戶安全)
                          </span>
                        </Grid>
                        <List className="w-100 pt-0">
                          <ListItem className="p-0"></ListItem>
                          <Divider component="li" />
                          <li></li>
                        </List>
                        <Grid
                          item
                          xs={12}
                          sm={2}
                          lg={2}
                          className="d-flex align-items-center"
                        >
                          <span className="text-dark ">現有密碼</span>
                        </Grid>
                        <Grid
                          item
                          xs={12}
                          sm={10}
                          lg={10}
                          className="d-flex align-items-center"
                        >
                          <input
                            id="currentPassword"
                            className={classes.input + " form-control"}
                            name="name"
                            disabled
                            {...formik.getFieldProps("currentPassword")}
                          />
                        </Grid>

                        <Grid
                          item
                          xs={12}
                          sm={2}
                          lg={2}
                          className="d-flex align-items-center"
                        >
                          <span className="text-dark ">新密碼</span>
                        </Grid>
                        <Grid
                          item
                          xs={12}
                          sm={10}
                          lg={10}
                          className="d-flex align-items-center"
                        >
                          <input
                            id="newPassword"
                            className={`${classes.input} form-control`}
                            name="newPassword"
                            onChange={formik.handleChange}
                            {...formik.getFieldProps("newPassword")}
                          />
                        </Grid>
                        <Grid
                          item
                          xs={12}
                          sm={2}
                          lg={2}
                          className="d-flex align-items-center"
                        >
                          <span className="text-dark ">確認新密碼</span>
                        </Grid>
                        <Grid
                          item
                          xs={12}
                          sm={10}
                          lg={10}
                          className="d-flex align-items-center"
                        >
                          <input
                            id="repeatNewPassword"
                            className={classes.input + " form-control"}
                            name="repeatNewPassword"
                            onChange={formik.handleChange}
                            {...formik.getFieldProps("repeatNewPassword")}
                          />
                        </Grid>

                        <List className="w-100">
                          <ListItem></ListItem>
                          <Divider component="li" />
                          <li></li>
                        </List>
                        <Grid
                          item
                          xs={12}
                          sm={12}
                          lg={12}
                          className="d-flex align-items-center"
                        >
                          {loading ? (
                            <div className={classes.input + " d-flex "}>
                              <Spinner animation="border" variant="primary" />
                            </div>
                          ) : (
                            <div className={classes.input + " d-flex "}>
                              <Button
                                variant="contained"
                                color="secondary"
                                className={classes.button}
                                onClick={formik.handleSubmit}
                              >
                                確認
                              </Button>
                            </div>
                          )}
                          {/* </Link> */}
                        </Grid>
                      </Grid>
                    </form>
                  </Paper>
                </>
              );
            }}
          </Formik>
        </>
      )}
    </>
  );
};

export default Registration;

// import React, { useState } from "react";
// import { useFormik } from "formik";
// import { connect } from "react-redux";
// import * as Yup from "yup";
// import { Link } from "react-router-dom";
// import { FormattedMessage, injectIntl } from "react-intl";
// // import { register } from "../../../api/authApi";
// import {REGISTER_URL} from "../../../api/authApi";
// import httpClientService from "../../../helpers/apiHelper";
// import {actions} from "../redux/actions";

// const initialValues = {
//   fullname: "",
//   email: "",
//   username: "",
//   password: "",
//   changepassword: "",
//   acceptTerms: false,
// };

// function Registration(props) {
//   const { intl } = props;
//   const [loading, setLoading] = useState(false);
//   const RegistrationSchema = Yup.object().shape({
//     fullname: Yup.string()
//       .min(3, "Minimum 3 symbols")
//       .max(50, "Maximum 50 symbols")
//       .required(
//         intl.formatMessage({
//           id: "AUTH.VALIDATION.REQUIRED_FIELD",
//         })
//       ),
//     email: Yup.string()
//       .email("Wrong email format")
//       .min(3, "Minimum 3 symbols")
//       .max(50, "Maximum 50 symbols")
//       .required(
//         intl.formatMessage({
//           id: "AUTH.VALIDATION.REQUIRED_FIELD",
//         })
//       ),
//     username: Yup.string()
//       .min(3, "Minimum 3 symbols")
//       .max(50, "Maximum 50 symbols")
//       .required(
//         intl.formatMessage({
//           id: "AUTH.VALIDATION.REQUIRED_FIELD",
//         })
//       ),
//     password: Yup.string()
//       .min(3, "Minimum 3 symbols")
//       .max(50, "Maximum 50 symbols")
//       .required(
//         intl.formatMessage({
//           id: "AUTH.VALIDATION.REQUIRED_FIELD",
//         })
//       ),
//     changepassword: Yup.string()
//       .required(
//         intl.formatMessage({
//           id: "AUTH.VALIDATION.REQUIRED_FIELD",
//         })
//       )
//       .when("password", {
//         is: (val) => (val && val.length > 0 ? true : false),
//         then: Yup.string().oneOf(
//           [Yup.ref("password")],
//           "Password and Confirm Password didn't match"
//         ),
//       }),
//     acceptTerms: Yup.bool().required(
//       "You must accept the terms and conditions"
//     ),
//   });

//   const enableLoading = () => {
//     setLoading(true);
//   };

//   const disableLoading = () => {
//     setLoading(false);
//   };

//   const getInputClasses = (fieldname) => {
//     if (formik.touched[fieldname] && formik.errors[fieldname]) {
//       return "is-invalid";
//     }

//     if (formik.touched[fieldname] && !formik.errors[fieldname]) {
//       return "is-valid";
//     }

//     return "";
//   };

//   const formik = useFormik({
//     initialValues,
//     validationSchema: RegistrationSchema,
//     onSubmit: (values, { setStatus, setSubmitting }) => {
//       setSubmitting(true);
//       enableLoading();

//       const email = values.email;
//       const fullname = values.fullname;
//       const username = values.username;
//       const password = values.password;

//       httpClientService('post', REGISTER_URL, 'tmp',{email, fullname, username, password})
//         .then(({ data: { accessToken } }) => {
//           props.register(accessToken);
//           disableLoading();
//           setSubmitting(false);
//         })
//         .catch(() => {
//           setSubmitting(false);
//           setStatus(
//             intl.formatMessage({
//               id: "AUTH.VALIDATION.INVALID_LOGIN",
//             })
//           );
//           disableLoading();
//         });
//     },
//   });

//   return (
//     <div className="login-form login-signin" style={{ display: "block" }}>
//       <div className="text-center mb-10 mb-lg-20">
//         <h3 className="font-size-h1">
//           <FormattedMessage id="AUTH.REGISTER.TITLE" />
//         </h3>
//         <p className="text-muted font-weight-bold">
//           Enter your details to create your account
//         </p>
//       </div>

//       <form
//         id="kt_login_signin_form"
//         className="form fv-plugins-bootstrap fv-plugins-framework animated animate__animated animate__backInUp"
//         onSubmit={formik.handleSubmit}
//       >
//         {/* begin: Alert */}
//         {formik.status && (
//           <div className="mb-10 alert alert-custom alert-light-danger alert-dismissible">
//             <div className="alert-text font-weight-bold">{formik.status}</div>
//           </div>
//         )}
//         {/* end: Alert */}

//         {/* begin: Fullname */}
//         <div className="form-group fv-plugins-icon-container">
//           <input
//             placeholder="Full name"
//             type="text"
//             className={`form-control form-control-solid h-auto py-5 px-6 ${getInputClasses(
//               "fullname"
//             )}`}
//             name="fullname"
//             {...formik.getFieldProps("fullname")}
//           />
//           {formik.touched.fullname && formik.errors.fullname ? (
//             <div className="fv-plugins-message-container">
//               <div className="fv-help-block">{formik.errors.fullname}</div>
//             </div>
//           ) : null}
//         </div>
//         {/* end: Fullname */}

//         {/* begin: Email */}
//         <div className="form-group fv-plugins-icon-container">
//           <input
//             placeholder="Email"
//             type="email"
//             className={`form-control form-control-solid h-auto py-5 px-6 ${getInputClasses(
//               "email"
//             )}`}
//             name="email"
//             {...formik.getFieldProps("email")}
//           />
//           {formik.touched.email && formik.errors.email ? (
//             <div className="fv-plugins-message-container">
//               <div className="fv-help-block">{formik.errors.email}</div>
//             </div>
//           ) : null}
//         </div>
//         {/* end: Email */}

//         {/* begin: Username */}
//         <div className="form-group fv-plugins-icon-container">
//           <input
//             placeholder="User name"
//             type="text"
//             className={`form-control form-control-solid h-auto py-5 px-6 ${getInputClasses(
//               "username"
//             )}`}
//             name="username"
//             {...formik.getFieldProps("username")}
//           />
//           {formik.touched.username && formik.errors.username ? (
//             <div className="fv-plugins-message-container">
//               <div className="fv-help-block">{formik.errors.username}</div>
//             </div>
//           ) : null}
//         </div>
//         {/* end: Username */}

//         {/* begin: Password */}
//         <div className="form-group fv-plugins-icon-container">
//           <input
//             placeholder="Password"
//             type="password"
//             className={`form-control form-control-solid h-auto py-5 px-6 ${getInputClasses(
//               "password"
//             )}`}
//             name="password"
//             {...formik.getFieldProps("password")}
//           />
//           {formik.touched.password && formik.errors.password ? (
//             <div className="fv-plugins-message-container">
//               <div className="fv-help-block">{formik.errors.password}</div>
//             </div>
//           ) : null}
//         </div>
//         {/* end: Password */}

//         {/* begin: Confirm Password */}
//         <div className="form-group fv-plugins-icon-container">
//           <input
//             placeholder="Confirm Password"
//             type="password"
//             className={`form-control form-control-solid h-auto py-5 px-6 ${getInputClasses(
//               "changepassword"
//             )}`}
//             name="changepassword"
//             {...formik.getFieldProps("changepassword")}
//           />
//           {formik.touched.changepassword && formik.errors.changepassword ? (
//             <div className="fv-plugins-message-container">
//               <div className="fv-help-block">
//                 {formik.errors.changepassword}
//               </div>
//             </div>
//           ) : null}
//         </div>
//         {/* end: Confirm Password */}

//         {/* begin: Terms and Conditions */}
//         <div className="form-group">
//           <label className="checkbox">
//             <input
//               type="checkbox"
//               name="acceptTerms"
//               className="m-1"
//               {...formik.getFieldProps("acceptTerms")}
//             />
//             <Link
//               to="/terms"
//               target="_blank"
//               className="mr-1"
//               rel="noopener noreferrer"
//             >
//               I agree the Terms & Conditions
//             </Link>
//             <span />
//           </label>
//           {formik.touched.acceptTerms && formik.errors.acceptTerms ? (
//             <div className="fv-plugins-message-container">
//               <div className="fv-help-block">{formik.errors.acceptTerms}</div>
//             </div>
//           ) : null}
//         </div>
//         {/* end: Terms and Conditions */}
//         <div className="form-group d-flex flex-wrap flex-center">
//           <button
//             type="submit"
//             disabled={
//               formik.isSubmitting ||
//               !formik.isValid ||
//               !formik.values.acceptTerms
//             }
//             className="btn btn-primary font-weight-bold px-9 py-4 my-3 mx-4"
//           >
//             <span>Submit</span>
//             {loading && <span className="ml-3 spinner spinner-white"></span>}
//           </button>

//           <Link to="/auth/login">
//             <button
//               type="button"
//               className="btn btn-light-primary font-weight-bold px-9 py-4 my-3 mx-4"
//             >
//               Cancel
//             </button>
//           </Link>
//         </div>
//       </form>
//     </div>
//   );
// }

// export default injectIntl(connect(null, actions)(Registration));
